import { planToTier, type SubscriptionPlan } from "@/shared/types";

/**
 * True when the user is on the free tier (no paid subscription).
 *
 * Used by the RFP Pack gates: free users can generate a single pack and
 * cannot download it — upgrade to Pro unlocks unlimited generation + downloads.
 */
export function isFreePlan(plan: SubscriptionPlan | null | undefined): boolean {
  return planToTier(plan ?? "free") === "free";
}